import type { CalculationKey } from '@/ts/types/calculation-config.type.ts'

export type CalculationErrorType = 'bmf' | 'other' | 'unknown'

const i18nMap: { [Key in CalculationErrorType]: string } = {
  bmf: 'error.calculation.bmf',
  other: 'error.calculation.other',
  unknown: 'error.calculation.unknown'
} as const

export class CalculationError extends Error {
  private readonly _type: CalculationErrorType
  private readonly _i18n: string

  constructor(calculationKey: CalculationKey, type: CalculationErrorType = 'unknown') {
    super(`An error occurred while calculating ${calculationKey}`)
    this._type = type
    this._i18n = i18nMap[this._type]
  }

  get i18n(): string {
    return this._i18n
  }
}
